import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getFunctions } from 'firebase/functions'
import { getStorage } from 'firebase/storage'

const firebaseConfig = {
  apiKey: "AIzaSyDGdBjwcOjKCf0x7T6s1KQOVJeJcJxX2ew",
  authDomain: "sweepicksapp.firebaseapp.com",
  projectId: "sweepicksapp",
  storageBucket: "sweepicksapp.firebasestorage.app",
  messagingSenderId: "191562064798",
  appId: "1:191562064798:web:76bc92a017c87f0a1e5e64",
  measurementId: "G-49F9RX0X6T"
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize services
export const auth = getAuth(app)
export const db = getFirestore(app)
export const functions = getFunctions(app)
export const storage = getStorage(app)

export default app